import Image from '@Components/Utils/Image';
import { FunctionComponent, useState } from 'react';

// Utils
import classnames from 'classnames';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';

// Styles
import styles from './Degree.module.scss';

// Icons
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse } from 'reactstrap';

interface DegreeData {
    name: string;
    issuer?: string;
    issueYear?: string;
}

interface DegreeProps {
    icon?: string;
    title?: string;
    degreeData?: Array<DegreeData>;
}

const Degree: FunctionComponent<DegreeProps> = ({ icon, title, degreeData }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const { deviceType } = useViewDetected();
    const length = degreeData?.length || 0;

    const toggle = () => setIsOpen((isOpen) => !isOpen);

    const renderDegreeItem = () => {
        return degreeData?.slice(0, 4).map((item, index) => (
            <div key={`degree-item-${index}`} className={styles.degree_item}>
                <Image src={icon} className={styles.icon_book} />
                <div className={styles.info_wrapper}>
                    <span className={styles.name}>{item.name}</span>
                    <span className={styles.description}>
                        {item.issuer} - {item.issueYear}
                    </span>
                </div>
            </div>
        ));
    };

    const className = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
    ]);

    return (
        <div className={className}>
            <div className={styles.body}>
                <div className={styles.title}>{title}</div>
                <div className={styles.degrees}>
                    {renderDegreeItem()}
                </div>

                <Collapse isOpen={isOpen} className={styles.collapse}>
                    <div className={styles.degrees}>
                        {degreeData?.slice(4, length).map((item, index) => (
                            <div key={`degree-item-${index}`} className={styles.degree_item}>
                                <Image src={icon} className={styles.icon_book} />
                                <div className={styles.info_wrapper}>
                                    <span className={styles.name}>{item.name}</span>
                                    <span className={styles.description}>
                                        {item.issuer} - {item.issueYear}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </Collapse>

                {length > 4 && (
                    <div className={styles.btn_button} onClick={toggle}>
                        <span className={styles.view_more}>
                            {isOpen ? (
                                <>
                                    <span>Thu gọn</span>
                                    <FontAwesomeIcon className={styles.icon_arrow} icon={faArrowDown} />
                                </>
                            ) : (
                                <>
                                    <span>Xem thêm</span>
                                    <FontAwesomeIcon className={styles.icon_arrow} icon={faArrowUp} />
                                </>
                            )}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

Degree.defaultProps = {
    icon: '',
    title: '',
    degreeData: [],
};

export default Degree;
